<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 160px;border-radius:5px;padding:5px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Rep. Art. S.S
    v-dialog(v-model='dialog3', persistent max-width='1200px')
      v-card
        v-card-text
          v-container(id="printJS-form")
            div(align='center')
              h4(style='font-weight: 700 !important;margin-bottom: 20px;') REPORTE DE ARTÍCULOS SIN STOCK
            br
            // Cabecera con logo y información
            div(style='display: flex;justify-content: center;align-items: center;margin-bottom: 30px;')
              v-layout(align-center='', justify-center='', row='', fill-height='')
                v-flex(xs6)
                  span.withTd3 EMPRESA: {{filtroEmpresa}}
                v-flex(xs6 style='text-align: right;')
                  span.withTd3 DESDE: {{dates[0] | moment('DD-MM-YYYY')}} - HASTA: {{dates[1] | moment('DD-MM-YYYY')}}

            // Tabla única con todos los renglones
            div(style='margin-top: 20px;')
            table(border="1" align="center" style='width: 100%;border-collapse: collapse;')
                thead
                tr(style='background-color: #333;color: white;')
                    th(style='padding: 10px;text-align: center;')
                        span.white--text COD-PEDIDO
                    th(style='padding: 10px;text-align: center;')
                        span.white--text COD-CLIENTE
                    th(style='padding: 10px;text-align: center;')
                        span.white--text NOMBRE-CLIENTE
                    th(style='padding: 10px;text-align: center;')
                        span.white--text NOMBRE-VENDEDOR
                    th(style='padding: 10px;text-align: center;')
                        span.white--text FECHA PEDIDO
                    th(style='padding: 10px;text-align: center;')
                        span.white--text CODIGO ART
                    th(style='padding: 10px;text-align: center;')
                        span.white--text DESCRIPCION
                    th(style='padding: 10px;text-align: center;')
                        span.white--text CANTIDAD
                tbody
                tr(v-for='(item, index) in getAllRenglones()' :key='index' :style='index % 2 === 0 ? "background-color: #f9f9f9;" : ""')
                    td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                        span {{item.doc_num || 'N/A'}}
                    td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                        span {{item.co_cli || 'N/A'}}
                    td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                        span {{item.cliente || 'N/A'}}
                    td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                        span {{item.vendedor || 'N/A'}}
                    td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                        span {{item.fec_emis | moment('DD-MM-YYYY HH:mm') || 'N/A'}}
                    td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                        span {{item.co_art || 'N/A'}}
                    td(style='padding: 8px;text-align: left;border: 1px solid #ddd;')
                        span {{item.des_art || 'N/A'}}
                    td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                        span {{item.total_art || 0}}

            // Resumen PDF con totales (aparece una sola vez al final)
            div(v-if='resumenPDF && resumenPDF.length > 0' style='margin-top: 30px;background-color: #f5f5f5;border: 2px solid #333;padding: 20px;border-radius: 5px;padding-bottom: 90px;')
                h5(style='text-align: center;margin-bottom: 20px;font-weight: bold;color: #333;') RESUMEN GENERAL DE ARTÍCULOS
                table(border="1" align="center" style='width: 100%;border-collapse: collapse;margin-bottom: 20px;')
                    thead
                        tr(style='background-color: #333;color: white;')
                            th(style='padding: 10px;text-align: center;width: 20%;')
                                span.white--text CÓDIGO ART
                            th(style='padding: 10px;text-align: center;width: 50%;')
                                span.white--text DESCRIPCIÓN
                            th(style='padding: 10px;text-align: center;width: 15%;')
                                span.white--text CANTIDAD TOTAL
                            th(style='padding: 10px;text-align: center;width: 15%;')
                                span.white--text REFERENCIA
                    tbody
                        tr(v-for='(item, index) in resumenPDF' :key='index' :style='index % 2 === 0 ? "background-color: #ffffff;" : "background-color: #f9f9f9;"')
                            td(style='padding: 8px;text-align: center;border: 1px solid #ddd;font-weight: bold;')
                                span {{item.co_art || 'N/A'}}
                            td(style='padding: 8px;text-align: left;border: 1px solid #ddd;')
                                span {{item.des_art || 'N/A'}}
                            td(style='padding: 8px;text-align: center;border: 1px solid #ddd;font-weight: bold;background-color: #e8f5e8;')
                                span {{item.total_art || 0}}
                            td(style='padding: 8px;text-align: center;border: 1px solid #ddd;')
                                span {{item.ref || 'N/A'}}
                
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close3()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog', persistent max-width='900px')
          v-container(style='background-color:white !important;max-width: 900px;')
            v-card-title.justify-center
                span.headline Detalles del Reporte
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            readonly
                            v-model="form.doc_num"
                            prepend-inner-icon="description"
                            label="Nro.:")
                            
                            v-text-field(outline
                            v-if='form.vendedor'
                            readonly
                            v-model="form.vendedor"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            v-if='form.cliente'
                            readonly
                            v-model="form.cliente"
                            prepend-inner-icon="description"
                            label="Cliente:")

                            div(v-if='form.renglones.length > 0')
                                v-card(style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                                    v-card-title.justify-center
                                        span PRODUCTOS
                                v-layout(align-start='', justify-start='', row='', fill-height='' style='border-bottom: 1px solid #dcd7d7;padding-bottom: 15px;')
                                    v-flex(xs2)
                                        span(style='font-weight: bold;font-size: 14px;') CODIGO
                                    v-flex(xs8 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-weight: bold;font-size: 14px;') NOMBRE
                                    v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-weight: bold;font-size: 14px;') CANTIDAD
                                v-layout(v-for='item in form.renglones' align-start='', justify-start='', row='', fill-height='' style='border-bottom: 1px solid #dcd7d7;padding-bottom: 15px;padding-top:15px;')
                                    v-flex(xs2)
                                        span(style='font-size: 14px;')  {{item.co_art}}
                                    v-flex(xs8 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-size: 14px;')  {{item.des_art}}
                                    v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-size: 14px;')  {{item.total_art}}
                            v-card-actions(style='margin-top: 20px;')
                                v-spacer
                                v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs4)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs4 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='empresas' v-model="filtroEmpresa" label="Empresas" @change='cambiarFiltroEmpresa()')
            v-flex(xs2 style='display: flex;align-items: center;justify-content: flex-end;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
            v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#ef8025' style='font-size: 1.70rem;') search
            a.mx-0(v-if='resultados && resultados.length > 0' @click='generarExcelPersonalizado' style='margin-left:10px !important;')
                img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
            a.mx-0(v-if='resultados && resultados.length > 0' @click='abrirPdf' style='margin-left:10px !important;')
                img(src='../assets/pdf.svg', style='height: 48px;width: auto;position: relative;top: 7px;right: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Reportes de Artículos Sin Stock
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.doc_num }}
            td {{ props.item.fec_emis | moment("DD/MM/YYYY") }}
            td(v-if='props.item.emp === "L"') {{ "Milo" }}
            td(v-if='props.item.emp === "I"') {{ "Grupo" }}
            td(v-if='props.item.vendedor') {{ props.item.vendedor }}
            td(v-else) N/A
            td(v-if='props.item.cliente') {{ props.item.cliente }}
            td(v-else) N/A
            td {{ props.item.total_renglones }}
            td.justify-start.layout.px-0
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='viewItem(props.item)' v-on="on" color='blue') visibility
                | Ver.
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import VueExcelXlsx from "vue-excel-xlsx";
import * as XLSX from 'xlsx';
import printJS from 'print-js'
import Vue from "vue";
Vue.use(VueExcelXlsx);

export default {
  data() {
    return {
      ruta: Api.images,
      search: "",
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      loading: false,
      modal: false,
      dates: [],
      date: null,
      dateFormatted: null,
      pagination: {
        rowsPerPage: 10
      },
      empresas: ["Todas", "Milo", "Grupo"],
      filtroEmpresa: "Todas",
      resumenPDF: [],
      headers: [
        { text: "Nro", value: "doc_num" },
        { text: "Fecha", value: "fec_emis" },
        { text: "Empresa", value: "emp" },
        { text: "Vendedor", value: "vendedor" },
        { text: "Cliente", value: "cliente" },
        { text: "Cantidad Renglones", value: "total_renglones" },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      columnsExcel: [
        { label: "TÍTULO", field: "tipo" },
        { label: "INFO", field: "doc_num" },
        { label: "COD-PEDIDO", field: "co_cli" },
        { label: "COD-CLIENTE", field: "cliente" },
        { label: "NOMBRE-CLIENTE", field: "vendedor" },
        { label: "NOMBRE-VENDEDOR", field: "fec_emis" },
        { label: "FECHA PEDIDO", field: "co_art" },
        { label: "CODIGO ART", field: "des_art" },
        { label: "DESCRIPCION", field: "total_art" },
        { label: "CANTIDAD", field: "ref" },
        { label: "REFERENCIA", field: "ref" }
      ],
      resultados: [],
      resultadosres: [],
      dataExcel: [],
      defaultForm: {
        doc_num: "",
        fec_emis: "",
        co_ven: "",
        co_cli: "",
        cliente: "",
        vendedor: "",
        emp: "",
        total_renglones: "",
        renglones: [],
      },
      form: {
        doc_num: "",
        fec_emis: "",
        co_ven: "",
        co_cli: "",
        cliente: "",
        vendedor: "",
        emp: "",
        total_renglones: "",
        renglones: [],
      },
      cre: "no",
      mod: "no",
      elm: "no"
    };
  },
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    }
  },
  mounted() {
    this.initialize();
    this.verificacion();
  },
  methods: {
    getAllRenglones() {
      let allRenglones = [];
      this.resultados.forEach(pedido => {
        if (pedido.renglones && pedido.renglones.length > 0) {
          pedido.renglones.forEach(renglon => {
            allRenglones.push({
              doc_num: pedido.doc_num,
              co_cli: pedido.co_cli,
              cliente: pedido.cliente,
              vendedor: pedido.vendedor,
              fec_emis: pedido.fec_emis,
              co_art: renglon.co_art,
              des_art: renglon.des_art,
              total_art: renglon.total_art
            });
          });
        }
      });
      return allRenglones;
    },
    close3() {
      this.dialog3 = false;
    },
    // Función de prueba para XLSX
    probarXLSX() {
      console.log("Probando XLSX...");
      console.log("XLSX disponible:", typeof XLSX !== 'undefined');
      
      // Crear Excel de prueba simple
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet([
        ["Prueba", "de", "XLSX"],
        ["Fila 2", "Columna 2", "Columna 3"],
        [1, 2, 3]
      ]);
      
      XLSX.utils.book_append_sheet(wb, ws, "Prueba");
      XLSX.writeFile(wb, "prueba.xlsx");
      
      console.log("Excel de prueba generado");
    },
    // Generar Excel personalizado con XLSX - Versión híbrida funcional
    generarExcelPersonalizado() {
      
      // Validar que hay datos
      if (!this.resultados || this.resultados.length === 0) {
        console.error("❌ No hay resultados para generar Excel");
        this.$swal.fire("Error", "No hay datos para generar el Excel", "error");
        return;
      }
      
      try {
        
        // Crear array base con datos simples
        const datosBase = [
          ["", "", "ARTICULOS SOLICITADO SIN STOCK", "", "", "", "", "", ""], // Fila 1 - Título en C
          ["", "", "EMPRESA", this.filtroEmpresa || 'N/A', "", "", "DESDE: " + this.$moment(this.dates[0]).format('DD-MM-YYYY') + " - HASTA: " + this.$moment(this.dates[1]).format('DD-MM-YYYY'), "", ""], // Fila 2
          ["", "", "", "", "", "", "", "", ""], // Fila 3 - vacía
          [], // Fila vacía
          ["COD-PEDIDO", "COD-CLIENTE", "NOMBRE-CLIENTE", "NOMBRE-VENDEDOR", "FECHA PEDIDO", "CODIGO ARTICULO", "NOMBRE ARTICULO", "CANTIDAD TOTAL", ""] // Encabezados desde A
        ];
        
        // Agregar datos de renglones
        this.resultados.forEach(pedido => {
          if (pedido.renglones && pedido.renglones.length > 0) {
            pedido.renglones.forEach(renglon => {
              datosBase.push([
                pedido.doc_num || '',
                pedido.co_cli || '',
                pedido.cliente || '',
                pedido.vendedor || '',
                pedido.fec_emis ? this.$moment(pedido.fec_emis).format('DD-MM-YYYY HH:mm') : '',
                renglon.co_art || '',
                renglon.des_art || '',
                renglon.total_art || 0,
                ""
              ]);
            });
          }
        });
        
        // Agregar resumenPDF
        if (this.resumenPDF && this.resumenPDF.length > 0) {
          // Línea separadora
          datosBase.push([]);
          
          // Título del resumen (comenzando en columna A)
          datosBase.push(["RESUMEN GENERAL", "", "", "", "", "", "", "", ""]);
          
          // Encabezados del resumen (directamente debajo del título, comenzando en columna A)
          datosBase.push(["CODIGO", "ARTICULO", "CANTIDAD", "", "", "", "", "", ""]);
          
          // Datos del resumen
          this.resumenPDF.forEach(item => {
            datosBase.push([
              item.co_art || '',
              item.des_art || '',
              item.total_art || 0,
              "", "", "", "", ""
            ]);
          });
        }
        
        // Crear worksheet con los datos
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(datosBase);
        
        // Definir anchos de columnas
        ws['!cols'] = [
          { width: 15 }, // A
          { width: 15 }, // B - COD-PEDIDO
          { width: 15 }, // C - COD-CLIENTE
          { width: 25 }, // D - NOMBRE-CLIENTE
          { width: 25 }, // E - NOMBRE-VENDEDOR
          { width: 20 }, // F - FECHA PEDIDO
          { width: 40 }, // G - CODIGO ARTICULO (más ancha)
          { width: 15 }, // H - NOMBRE ARTICULO (más estrecha)
          { width: 15 }, // I - CANTIDAD TOTAL
        ];
        
        // Aplicar estilos y merges solo a celdas específicas
        ws['!merges'] = [];
        
        // Estilo base para todas las celdas: tamaño 9
        const estiloBase = { font: { sz: 9 } };
        
        // Aplicar estilo base a todas las celdas
        for (let i = 0; i < datosBase.length; i++) {
          for (let j = 0; j < datosBase[i].length; j++) {
            const celda = XLSX.utils.encode_cell({ r: i, c: j });
            if (ws[celda]) {
              ws[celda].s = { ...estiloBase, ...(ws[celda].s || {}) };
            }
          }
        }
        
        // Combinar título C1:I1
        ws['!merges'].push({ s: { r: 0, c: 2 }, e: { r: 0, c: 8 } });
        ws['C1'].s = {
          font: { sz: 9, bold: true },
          alignment: { horizontal: "center", vertical: "center" },
          fill: { fgColor: { rgb: "333333" } }
        };
        
        // Estilo para C2 (EMPRESA) - negrita
        ws['C2'].s = { 
          font: { sz: 9, bold: true },
          alignment: { horizontal: "left", vertical: "center" }
        };
        
        // Estilo para D2 (filtroEmpresa) - normal
        ws['D2'].s = { 
          font: { sz: 9 },
          alignment: { horizontal: "left", vertical: "center" }
        };
        
        // Combinar fechas H2:I2
        ws['!merges'].push({ s: { r: 1, c: 7 }, e: { r: 1, c: 8 } });
        ws['H2'].s = {
          font: { sz: 9, bold: true },
          alignment: { horizontal: "center", vertical: "center" }
        };
        
        // Estilo para encabezados (fila 5, índice 4) - negrita con fondo gris
        const estiloEncabezado = {
          font: { sz: 9, bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "808080" } }, // Fondo gris
          alignment: { horizontal: "center", vertical: "center" }
        };
        
        for (let col = 0; col <= 7; col++) {
          const celda = XLSX.utils.encode_cell({ r: 4, c: col });
          if (ws[celda]) {
            ws[celda].s = estiloEncabezado;
          }
        }
        
        // Estilos para resumen si existe
        if (this.resumenPDF && this.resumenPDF.length > 0) {
          // Encontrar la fila del resumen
          let filaResumen = -1;
          for (let i = 0; i < datosBase.length; i++) {
            if (datosBase[i][0] === "RESUMEN GENERAL") {
              filaResumen = i;
              break;
            }
          }
          
          if (filaResumen > 0) {
            // Combinar título del resumen (desde columna A hasta H)
            ws['!merges'].push({ s: { r: filaResumen, c: 0 }, e: { r: filaResumen, c: 8 } });
            ws[XLSX.utils.encode_cell({ r: filaResumen, c: 0 })].s = {
              font: { sz: 9, bold: true },
              fill: { fgColor: { rgb: "F5F5F5" } }
            };
            
            // Estilo para encabezados del resumen (fila siguiente al título) - negrita con fondo gris
            const estiloEncabezadoResumen = {
              font: { sz: 9, bold: true, color: { rgb: "FFFFFF" } },
              fill: { fgColor: { rgb: "808080" } }, // Fondo gris
              alignment: { horizontal: "center", vertical: "center" }
            };
            
            const filaEncabezadosResumen = filaResumen + 1; // Directamente debajo del título
            // Aplicar estilos a columnas A, B, C (índices 0, 1, 2)
            for (let col = 0; col <= 2; col++) {
              const celda = XLSX.utils.encode_cell({ r: filaEncabezadosResumen, c: col });
              if (ws[celda]) {
                ws[celda].s = estiloEncabezadoResumen;
              }
            }
          }
        }
        
        // Agregar worksheet al workbook
        XLSX.utils.book_append_sheet(wb, ws, "Artículos Sin Stock");
        
        // Generar y descargar archivo
        XLSX.writeFile(wb, "Milo-ArticulosSinStock.xlsx");
        
      } catch (error) {
        console.error("❌ Error generando Excel:", error);
        console.error("Stack trace:", error.stack);
        this.$swal.fire("Error", "Ocurrió un error al generar el Excel: " + error.message, "error");
      }
    },
    resPDF(){
      // Agrupar artículos por co_art y sumar cantidades
      this.resumenPDF = [];
      
      // Crear mapa para agrupar por co_art
      const articulosMap = new Map();
      
      // Recorrer todos los resultados
      this.resultados.forEach(pedido => {
        if (pedido.renglones && pedido.renglones.length > 0) {
          pedido.renglones.forEach(renglon => {
            const key = renglon.co_art;
            
            if (articulosMap.has(key)) {
              // Si ya existe, sumar la cantidad
              const existente = articulosMap.get(key);
              existente.total_art += (renglon.total_art || 0);
              existente.des_art = renglon.des_art || existente.des_art; // Mantener descripción
            } else {
              // Si no existe, agregar nuevo
              articulosMap.set(key, {
                co_art: renglon.co_art,
                des_art: renglon.des_art,
                total_art: renglon.total_art || 0,
                ref: renglon.ref
              });
            }
          });
        }
      });
      
      // Convertir mapa a array
      this.resumenPDF = Array.from(articulosMap.values());
      
      // Ordenar por co_art
      this.resumenPDF.sort((a, b) => (a.co_art || '').localeCompare(b.co_art || ''));
    },
    abrirPdf() {
      this.resPDF();
      this.dialog3 = true;
    },
    imprimirPdf() {
      printJS({
        printable: 'printJS-form',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        css: 'printPdf',
        orientation: 'landscape'
      })
    },
    cambiarFiltroEmpresa() {
      let data = this.filtroEmpresa
      if (data) {
        let empresa = ""
        if (data === "Milo") {
          empresa = "L"
        } else if (data === "Grupo") {
          empresa = "I"
        }
        this.resultados = []
        this.dataExcel = []
        let res = []
        for (let i = 0; i < this.resultadosres.length; i++) {
          const el = this.resultadosres[i];
          if (data === "Todas") {
            res.push(el)
          } else if (el.emp === empresa) {
            res.push(el)
          }
        }
        
        // Generar datos para Excel con estructura similar al PDF
        this.dataExcel = []
        
        // Agregar encabezados del reporte
        this.dataExcel.push({
          tipo: "TÍTULO",
          doc_num: "REPORTE DE ARTÍCULOS SIN STOCK",
          co_cli: "",
          cliente: "",
          vendedor: "",
          fec_emis: "",
          co_art: "",
          des_art: "",
          total_art: "",
          ref: ""
        })
        
        // Agregar información de empresa y fechas
        this.dataExcel.push({
          tipo: "INFO",
          doc_num: "EMPRESA: " + data,
          co_cli: "",
          cliente: "",
          vendedor: "",
          fec_emis: "DESDE: " + this.$moment(this.dates[0]).format('DD-MM-YYYY') + " - HASTA: " + this.$moment(this.dates[1]).format('DD-MM-YYYY'),
          co_art: "",
          des_art: "",
          total_art: "",
          ref: ""
        })
        
        // Línea separadora
        this.dataExcel.push({
          tipo: "",
          doc_num: "",
          co_cli: "",
          cliente: "",
          vendedor: "",
          fec_emis: "",
          co_art: "",
          des_art: "",
          total_art: "",
          ref: ""
        })
        
        // Agregar detalle de cada pedido con sus renglones
        res.forEach(pedido => {
          if (pedido.renglones && pedido.renglones.length > 0) {
            pedido.renglones.forEach(renglon => {
              this.dataExcel.push({
                tipo: "DETALLE",
                doc_num: pedido.doc_num || '',
                co_cli: pedido.co_cli || '',
                cliente: pedido.cliente || '',
                vendedor: pedido.vendedor || '',
                fec_emis: this.$moment(pedido.fec_emis).format('DD-MM-YYYY HH:mm'),
                co_art: renglon.co_art || '',
                des_art: renglon.des_art || '',
                total_art: renglon.total_art || 0,
                ref: renglon.ref || ''
              })
            })
          }
        })
        
        // Agregar resumen consolidado
        if (this.resumenPDF && this.resumenPDF.length > 0) {
          // Línea separadora
          this.dataExcel.push({
            tipo: "RESUMEN",
            doc_num: "",
            co_cli: "",
            cliente: "",
            vendedor: "",
            fec_emis: "",
            co_art: "",
            des_art: "",
            total_art: "",
            ref: ""
          })
          
          // Agregar artículos del resumen
          this.resumenPDF.forEach(item => {
            this.dataExcel.push({
              tipo: "RESUMEN",
              doc_num: "",
              co_cli: "",
              cliente: "",
              vendedor: "",
              fec_emis: "",
              co_art: item.co_art || '',
              des_art: item.des_art || '',
              total_art: item.total_art || 0,
              ref: item.ref || ''
            })
          })
          
          // Línea de totales
          this.dataExcel.push({
            tipo: "TOTAL",
            doc_num: "TOTAL PEDIDOS: " + res.length,
            co_cli: "",
            cliente: "",
            vendedor: "",
            fec_emis: "",
            co_art: "ARTÍCULOS DIFERENTES: " + this.resumenPDF.length,
            des_art: "",
            total_art: "TOTAL UNIDADES: " + this.resumenPDF.reduce((sum, item) => sum + (item.total_art || 0), 0),
            ref: ""
          })
        }
        
        this.$nextTick(() => {
          this.resultados = res
          this.resPDF();
        })
      }
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminmilo.permisos.length; i++) {
        if (this.$store.state.adminmilo.permisos[i].ruta === "RepArtSS") {
          for (
            let j = 0;
            j < this.$store.state.adminmilo.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      this.dialog4 = true;
      if (this.dates.length > 1) {
        let desde = this.$moment(this.dates[0]).format('YYYY-MM-DD')
        let hasta = this.$moment(this.dates[1]).format('YYYY-MM-DD')
        let empresa = this.filtroEmpresa.toLowerCase() === 'todos' ? '' : this.filtroEmpresa
        
        Api.get('/renglon/repArtSS?inicio=' + desde + '&fin=' + hasta + '&empresa=' + empresa)
        .then(res => {
          this.dialog4 = false;
          if (res.data) {
            this.resultados = [];
            this.resultadosres = [];
            this.dataExcel = []
            
            if (res.data && res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const el = res.data[i];
                this.resultados.push(el)
                this.resultadosres.push(el)
              }
              
              // Generar resumenPDF
              this.resPDF();
              
            }
          }
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dataExcel = []
      this.resumenPDF = []
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    viewItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    transform(value) {
      if (value) {
        let val
        val = parseFloat(value)
        val = parseFloat(val).toFixed(2)
        val = val.toString().split('.')
        if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
        return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
      } else {
        return value
      }
    }
  }
};
</script>
<style lang="scss">
.printPdf {
    @page :footer {
        display: none
    }
 
    @page :header {
        display: none
    }
}
.borderTb {
  border: 1px solid;
  text-align: center;
  width: 160px;
}
.withTd {
  width: 160px;
}
.textGrn {
  width: 100%;
  text-align: center;
}
.withTd2 {
  border: 2px solid;
  padding: 4px;
  font-weight: bold;
}
.withTd4 {
  border: 2px solid;
  padding: 4px;
  font-weight: bold;
  background-color: #ef8025;
}
.withTd3 {
  padding: 4px;
  font-weight: bold;
}
.withTd5 {
  font-weight: bold;
}
.paddText {
  padding-right: 10px;
  font-size: 14px;
  font-weight: bold;
}
.divRect {
  width: 100px;
  height: 30px;
  border: 2px solid;
}
.divPrin {
  display: flex;
  align-items: center;
}
.divProd {
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divCli {
  margin-top: 20px;
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#printJS-form {
  table, th, td {
    border-collapse: collapse;
  }
}
</style>
